import React, { useState, useEffect, useRef } from 'react';
import ConfModal from '../../../Components/common/ConfModal.js';
import { Button, Form, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { CallApi } from '../../../Components/common/CommonFunctions';

const General = () => {

  const isMounted = useRef(false);
  const [selectedCurrency, setSelectedCurrency] = useState('');
  const [modalConf, setModalConf] = useState(false);
  const [handlerMail, setHandlerMail] = useState(false);
  const [confData, setConfData] = useState({});

  const currencyOptions = [
    { value: "EUR", label: "EUR (€) - Euro", symbol: '€' },
    { value: "USD", label: "USD ($) - US Dollar", symbol: '$' },
    { value: "PHP", label: "PHP (₱) - Philippine Peso", symbol: '₱' },
    { value: "JPY", label: "JPY (¥) - Japanese Yen", symbol: '¥' },
    { value: "GBP", label: "GBP (£) - British Pound", symbol: '£' },
    { value: "AUD", label: "AUD (A$) - Australian Dollar", symbol: 'A$' },
    { value: "CHF", label: "CHF (Fr.) - Swiss Franc", symbol: 'Fr.' },
    { value: "CAD", label: "CAD (C$) - Canadian Dollar", symbol: 'C$' },
    { value: "MXN", label: "MXN ($) - Mexican Peso", symbol: '$' },
    { value: "CNY", label: "CNY (¥) - Chinese Yuan", symbol: '¥' },
    { value: "NZD", label: "NZD (NZ$) - New Zealand Dollar", symbol: 'NZ$' },
    { value: "SEK", label: "SEK (kr) - Swedish Krona", symbol: 'kr' },
    { value: "RUB", label: "RUB (₽) - Russian Ruble", symbol: '₽' },
    { value: "HKD", label: "HKD (HK$) - Hong Kong Dollar", symbol: 'HK$' },
    { value: "NOK", label: "NOK (kr) - Norwegian Krone", symbol: 'kr ' },
    { value: "SGD", label: "SGD (S$) - Singapore Dollar", symbol: 'S$' },
    { value: "TRY", label: "TRY (₺) - Turkish Lira", symbol: '₺' },
    { value: "KRW", label: "KRW (₩) - South Korean Won", symbol: '₩' },
    { value: "ZAR", label: "ZAR (R) - South African Rand", symbol: 'R' },
    { value: "BRL", label: "BRL (R$) - Brazilian Real", symbol: 'R$' },
    { value: "INR", label: "INR (₹) - Indian Rupee", symbol: '₹' },
    { value: "SAR", label: "SAR (﷼) - Saudi Riyal", symbol: '﷼' },
    { value: "DKK", label: "DKK (kr) - Danish Krone", symbol: 'kr' },
    { value: "RON", label: "RON (lei) - Romanian Leu", symbol: 'lei' },
    { value: "XAF", label: "XAF (Fr) - Central African CFA Franc", symbol: 'Fr' },
    { value: "XOF", label: "XOF (Fr) - West African CFA Franc", symbol: 'Fr' },
    { value: "DOP", label: "DOP (RD$) - Dominican Peso", symbol: 'RD$)' },
    { value: "HTG", label: "HTG (G) - Haitian Gourde", symbol: 'G' },
    { value: "BBD", label: "BBD (Bds$) - Barbadian Dollar", symbol: 'Bds$' },
    { value: "TTD", label: "TTD (TT$) - Trinidad and Tobago Dollar", symbol: 'TT$)' },
    { value: "XCD", label: "XCD (EC$) - East Caribbean Dollar", symbol: 'EC$' },
    { value: "ANG", label: "ANG (ƒ) - Netherlands Antillean Guilder", symbol: 'ƒ' },
    { value: "COP", label: "COP (COL$) - Colombian Peso", symbol: 'COL$' },
    { value: "XDR", label: "XDR (SDR) - IMF Special Drawing Rights", symbol: 'SDR' },
    { value: "XBT", label: "XBT (₿) - Bitcoin", symbol: '₿' },
    { value: "WGH", label: "WGH - West German Hard Currency", symbol: 'WGH' },
  ];

  const fetchSettings = async () => {
    CallApi({
      endPoint: 'general-setting/get-setting',
      method: 'GET',
      onSuccess: (res) => {
        const innerData = res?.data?.response_data?.settings;
        console.log("innerData", innerData)
        setSelectedCurrency(innerData?.currency || 'EUR')
        setHandlerMail(innerData?.handler_email == 1 ? true : false || false)
      },
      onError: (msg) => toast.error(msg)
    });
  };

  useEffect(() => {
    if (isMounted.current) return;
    fetchSettings()
    isMounted.current = true;
  }, []);
  const handleCurrencyChange = async (event) => {
    const { name, value } = event.target;
    // const numericValue = value.replace(/\D/g, "");
    // setSelectedCurrency(value)
    CallApi({
      endPoint: 'general-setting/save-setting',
      payload: { settings: { currency: value } },
      onSuccess: (res) => {
        if (res.data.response_code === 200) {
          const innerData = res.data.response_data;
          // setSelectedCurrency(innerData);
          fetchSettings();
        };
      },
      onError: (msg) => toast.error(msg)
    });
  }

  const switchChange = (e) => {
    const isChecked = e.target.checked;

    setConfData({
      header: `${isChecked ? 'Active' : 'De-Active'}  atomatic mail sending`,
      subHeader: `If you confirm this, Automatically email sending will be ${isChecked ? 'Activated' : 'Deactivated'}`,
      modalConf: () => tabChangeConf(isChecked),
      closeModal: confModalClose,
      primaryBtn: 'Yes',
      secondaryBtn: 'No',
    })
    setModalConf(true);
  }

  const confModalClose = () => {
    setModalConf(false);
  }
  const tabChangeConf = async (mode) => {
    //  console.log("🚀 ~ switchChange ~ mode:", mode)
    CallApi({
      endPoint: 'general-setting/save-setting',
      payload: { settings: { handler_email: mode } },
      onSuccess: (res) => {
        if (res.data.response_code === 200) {
          const innerData = res.data.response_data;
          // setSelectedCurrency(innerData);
          fetchSettings();
        };
      },
      onError: (msg) => toast.error(msg)
    });
  }

  return (
    <>
      {modalConf &&
        <ConfModal
          header={confData.header}
          subHeader={confData.subHeader}
          modalConf={confData.modalConf}
          closeModal={confData.closeModal}
          primaryBtn={confData.primaryBtn}
          secondaryBtn={confData.secondaryBtn}
        />
      }
      <div>
        <h4>General Settings</h4>
        <p>Set your notification preferences for when you are in or away from the dashboard.</p>
      </div>
      <hr />
      <div className='mb-2'>
          <h5>Default Currency</h5>
          <p>Set default currency used in the system.</p>
        <div className='st_days w-25'>
          <Form.Select size="sm" className="euro_amount_select" value={selectedCurrency} onChange={handleCurrencyChange}>
            {currencyOptions.map(opt => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </Form.Select>
        </div>
      </div>

      <div className=''>
        <div className='me-3'>
          <h5>Automatic Email Sending</h5>
          <p>Enable to allow the system to sent automatic emails to handlers.</p>
        </div>
        <div className='st_days'>
          <div className="new_tgl me-3">
            <label className="switch">
              <input
                type="checkbox"
                checked={handlerMail}
                onChange={switchChange}
                id={`custom-switch`}
              />
              <span className="slider-text">
                <span className="off">
                  No <span className="circle"></span>
                </span>
                <span className="on">
                  Yes <span className="checkmark">✓</span>
                </span>
              </span>
            </label>
          </div>
        </div>
      </div>
    </>
  )
}

export default General;